import React, {useEffect, useState} from 'react'
import {Alert, Select, Spin} from "antd"
import {listSku} from "../../../../services/api/3dApi"

const {Option} = Select

function FilterProductType(props) {
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [types, setTypes] = useState(props.productTypes)
    const [options, setOptions] = useState()

    function _handleChange(value) {
        const {onChangeProductType} = props

        if (typeof onChangeProductType === 'function') {
            onChangeProductType(value)
        }
    }

    async function _fetchOrderTypes() {
        setError('')
        setLoading(true)

        try {
            const {data: response} = await listSku()

            const {data, success, error} = response

            if (!success) {
                setError(error)
                return setLoading(false)
            }

            const regex = /\s/

            const newData = data.length > 0 && data.filter((item) => {
                return !regex.test(item.sku) && item
            })

            setLoading(false)
            setOptions(newData)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    useEffect(() => {
        setTypes(props.productTypes)
    }, [props.productTypes])

    useEffect(() => {
        _fetchOrderTypes()
        // eslint-disable-next-line
    }, [])

    const listOption = !!options && options.length > 0 && options.reduce((unique, obj) => {
        if (!unique.some(item => item.id === obj.id && item.sku === obj.sku)) {
          unique.push(obj);
        }
        return unique;
    }, []);

    return (
        <div className="FilterProductType">
            {error ? <Alert message={error} type={'error'}/> :
                <Spin spinning={loading}>
                    <Select
                        mode="multiple"
                        style={{width: '100%'}}
                        showArrow={true}
                        placeholder="Vui lòng chọn loại sản phẩm bạn muốn tìm kiếm"
                        defaultValue={types}
                        optionFilterProp="children"
                        onChange={_handleChange}
                        value={types}
                    >
                        {!!listOption && listOption.length > 0 && 
                            listOption.map((option) => {
                                return <Option key={option._id} value={option.sku}>{option.sku}</Option>
                            })
                        }
                    </Select>
                </Spin>
            }
        </div>
    )
}

export default FilterProductType
